


























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import clipboard from 'clipboard';
import swert from '@/component/swert.vue';

const param = require('bmh/param');
const utmTerm = param('utm_term');

const mobiletest = new RegExp('Mobile');
const IS_M_CLIENT = mobiletest.test(navigator.userAgent);

@Component({
  components: {
    swert,
  }
})
export default class Home extends Vue {
  isShowWechat: boolean = false;
  isShowMobile: boolean = false;
  isShowOrder: boolean = false;
  mobile: string = '';
  IS_M_CLIENT: boolean = IS_M_CLIENT;
  wechatID: string = '';
  isApplying: boolean = false;
  swertMsg: string = '';

  swert(msg: string) {
    this.swertMsg = msg;
  }
  clickMoblie() {
    if (IS_M_CLIENT) {
      window.location.href = 'tel:13157193915';
    } else {
      this.isShowMobile = true;
    }
  }
  orderApply() {
    if (this.mobile && (/^1[3456789]\d{9}$/.test(this.mobile))) {
      const sendData = { mobile: this.mobile, entry_id: '', source: IS_M_CLIENT ? 'M' : 'PC' , utm_term: utmTerm };
      if (IS_M_CLIENT) {
        sendData.entry_id = '745802';
      } else {
        sendData.entry_id = '645802';
      }
      this.isApplying = true;
      this.$axios.post('//api.liuliangphone.com/m/merchant/recruit/apply', sendData).then((res: AxiosResponse) => {
        if (res.data.error === 0) {
          this.swert('预约成功');
          this.isShowOrder = false;
          this.mobile = '';
          this.isApplying = false;
        } else {
          this.swert(res.data.message);
          this.isApplying = false;
        }
      }).catch((err): any => {
        console.log(err);
      });
    } else {
      this.swert('请输入正确手机号');
    }
  }
  mounted() {
    const clipboardWechat: any = new clipboard('.copy-button');
    clipboardWechat.on('success', () => {
      this.swert('复制成功');
    });
    clipboardWechat.on('error', () => {
      this.swert('复制失败，请手动选择复制！');
    });
    window.SHARE = {
      title: '流量蜂用户增长系统', // 分享标题
      description: '构建和保护你的私域流量池', // 分享描述
      url: window.location.href, // 分享链接
      icon_url: 'https://pic.liuliangphone.com/share-img-llf.png', // 分享图片
    };
    this.$wx.bindShare();
    this.$wx.bindShareTimeLine();
  }
}
